/* unplugin-vue-components disabled */import { ElCheckboxGroup as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/checkbox-group/style/css';
import { ElCheckbox as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/checkbox/style/css';
import { ElTag as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/tag/style/css';
import "core-js/modules/es.array.push.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "select_box"
};
var _hoisted_2 = {
  class: "input_box",
  style: {
    "width": "80%"
  }
};
var _hoisted_3 = {
  class: "title_box"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "options_box"
};
import { sample_product_class_list } from "@/api/apis";
import { watch, watchEffect } from "vue";
import { useUserStore } from "@/store/user";
import { useSampleStore } from "@/store/sample";
import { useRoute } from "vue-router";
export default {
  __name: 'selectSupplies',
  props: ["check_name", "check_id"],
  emits: ["onSelectWl"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var sampleStore = useSampleStore();
    var useStore = useUserStore();
    var route = useRoute();
    var list = ref([]);
    var props = __props;
    var checkArr = ref([]);
    var checkList = ref([]);
    // watch(
    //   () => {
    //     return props.check_name;
    //   },
    //   (val) => {
    //     if (val) {
    //       checkList.value.push(val);
    //     }
    //   }
    // );
    watch(() => {
      return route.params.id;
    }, val => {
      // checkList_format.value = [];
      checkList.value = [];
    });
    watch(() => {
      return props.check_id;
    }, val => {
      if (val) {
        console.log("val", val);
        checkArr.value = val;
        checkList.value = [];
        sampleStore.get_supplies_type().then(res => {
          var list_temp = list_format(res);
          list_temp.map(item => {
            item.child.map(list => {
              if (val.findIndex(x => x == list.id) > -1) {
                checkList.value.push(list);
              }
            });
          });
          checkList.value.map(item => {
            var type_name = item.type == 1 ? "标准品" : item.type == 2 ? "模块化标准产品" : "定制品";
            item.tagName = type_name + "-" + item.name;
          });
          console.log("checkList.value", checkList.value);
          emit("onSelectWl", checkList.value);
        });
      }
    }, {
      immediate: true
    });
    var emit = __emit;
    var handle_body_click = e => {
      // let class_name = e.target.parentNode?.parentNode?.parentNode?.className;
      // console.log("body被监听", class_name);
      var class_name = "";
      var current_node = e.target;
      var i = 6;
      while (i > 0 && class_name != "select_box") {
        var _current_node, _current_node2;
        current_node = (_current_node = current_node) === null || _current_node === void 0 ? void 0 : _current_node.parentNode;
        class_name = (_current_node2 = current_node) === null || _current_node2 === void 0 ? void 0 : _current_node2.className;
        i--;
      }
      if (class_name == "select_box") {
        useStore.isFouce = "wl";
      } else {
        useStore.isFouce = "";
      }
    };
    document.querySelector("body").addEventListener("click", handle_body_click, {
      capture: true
    });
    var search_name = ref("");
    var get_data = () => {
      sample_product_class_list({
        type: 2,
        key_word: search_name.value
      }).then(res => {
        if (res.code == 200) {
          list.value = list_format(res.data.list);
          console.log("打印list.value===", list.value);
          current_item.value = list.value[0];
          current_index.value = 0;
        }
      });
    };
    function list_format(arr) {
      return arr.map(x => {
        x.child.map(a => {
          a.type = x.type;
          return a;
        });
        return x;
      });
    }
    // get_data();
    sampleStore.get_supplies_type().then(res => {
      list.value = list_format(res);
      current_item.value = list.value[0];
    });
    var current_index = ref(0); // 当前选择的分类
    var current_item = ref(""); // 当前选择的分类内容
    var change_type = (item, index) => {
      current_index.value = index;
      current_item.value = item;
    };
    var timer = "";
    var handle_filter = () => {
      console.log("切换了");
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        console.log("请求数据");
        get_data();
      }, 500);
    };
    var handle_change = (e, item) => {
      if (search_name.value) {
        search_name.value = "";
      }
      var checkindex = checkList.value.findIndex(x => x.id == item.id);
      if (e && checkindex == -1) {
        checkList.value.push(item);
      } else {
        if (!e && checkindex > -1) {
          checkList.value.splice(checkindex, 1);
        }
      }
      checkList.value.map(item => {
        var type_name = item.type == 1 ? "标准品" : item.type == 2 ? "模块化标准产品" : "定制品";
        item.tagName = type_name + "-" + item.name;
      });
      emit("onSelectWl", checkList.value);
      console.log("checkList.value==>", checkList.value);
    };
    var _get_detail = function get_detail(obj, target) {
      var num = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var filed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "name";
      var result = {};
      if (obj.type) {
        return obj;
      } else {
        for (var i = 0; i < target.length; i++) {
          var item = target[i];
          if (item[filed] == obj[filed] && num) {
            return item;
          } else {
            if (item.child && item.child.length != 0) {
              result = _get_detail(obj, item.child, num + 1, filed);
              if (result) {
                return result;
              }
            }
          }
        }
      }
    };
    /**
     * 删除已选择的
     */
    var handle_close = (item, index) => {
      checkList.value.splice(index, 1);
      checkArr.value = checkArr.value.filter(x => {
        return item.id != x;
      });
      handle_change(false, item);
    };

    /**
     * 页面销毁之前的生命周期
     */
    onBeforeUnmount(() => {
      console.log("页面销毁");

      // 移除监听
      document.querySelector("body").removeEventListener("click", handle_body_click);
    });
    return (_ctx, _cache) => {
      var _component_el_tag = __unplugin_components_0;
      var _component_el_checkbox = __unplugin_components_1;
      var _component_el_checkbox_group = __unplugin_components_2;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkList), (tag, index) => {
        return _openBlock(), _createBlock(_component_el_tag, {
          key: tag,
          class: "mx-1",
          closable: "",
          type: "info",
          onClose: $event => handle_close(tag, index),
          style: {
            "margin": "2px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(tag.tagName), 1)]),
          _: 2
        }, 1032, ["onClose"]);
      }), 128)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(search_name) ? search_name.value = $event : null),
        onInput: handle_filter
      }, null, 544), [[_vModelText, _unref(search_name)]]), _createElementVNode("span", {
        class: _normalizeClass(['iconfont', 'icon-jiantouxia', _unref(useStore).isFouce == 'wl' ? 'arrow_top' : ''])
      }, null, 2)]), _createElementVNode("div", {
        class: _normalizeClass(["body_select", [_unref(useStore).isFouce == 'wl' ? 'is_show' : 'is_no_show']]),
        name: "wl2"
      }, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "level1"
        }, [_createElementVNode("span", {
          class: _normalizeClass(['level1_title', _unref(current_index) == index ? 'is_active' : '']),
          onClick: $event => change_type(item, index)
        }, _toDisplayString(item.name), 11, _hoisted_4)]);
      }), 128))]), _createElementVNode("div", _hoisted_5, [_unref(current_item).child && _unref(current_item).child.length != 0 ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
        key: 0,
        modelValue: _unref(checkArr),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(checkArr) ? checkArr.value = $event : null)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(current_item).child, (item2, i) => {
          return _openBlock(), _createBlock(_component_el_checkbox, {
            key: i,
            label: item2.id,
            onChange: e => {
              handle_change(e, item2);
            },
            disabled: item2.id == 482 || item2.id == 483
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item2.name), 1)]),
            _: 2
          }, 1032, ["label", "onChange", "disabled"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true)])], 2)]);
    };
  }
};